import React, { useEffect, useState } from 'react';
import { omit } from 'lodash';
import moment from 'moment';

import { Button, DatePicker, IconButton, Stack, Text, TextInput } from 'shell/components';

const ProjectSettings = ({ device, isOpen, project, updateProjectSettings, onClose }) => {
    const defaultFormValues = {
        isDirty: false,
        title: project?.title || '',
        start_on: project?.start_on || 0,
        end_on: project?.end_on || 0,
    };

    const [form, setForm] = useState(defaultFormValues);
    const [errors, setErrors] = useState({ title: '' });

    const handleChange = (key, value) => {
        return setForm((current) => ({ ...current, isDirty: true, [key]: value }));
    };

    const handleClick = () => {
        updateProjectSettings(omit(form, ['isDirty']));
        onClose();
    };

    useEffect(() => {
        if (!isOpen) setForm(defaultFormValues);
    }, [isOpen]);

    useEffect(() => {
        if (project) setForm(defaultFormValues);
    }, [project]);

    useEffect(() => {
        if (!form) return;
        setErrors((current) => ({ ...current, title: form.title ? '' : 'Project title is required.' }));
    }, [form]);

    const canSubmit = form.isDirty && !Boolean(Object.values(errors).reduce((acc, cur) => cur + acc, ''));

    return (
        <Stack spacing={4}>
            <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                <Text variant={'h6'}>Edit Project Settings</Text>
                <IconButton kind={'exit'} size={'medium'} variant={'square'} onClick={onClose} />
            </Stack>
            <TextInput
                error={Boolean(errors.title)}
                helperText={errors.title}
                label={'Project Title'}
                required
                value={form.title}
                onChange={(e) => handleChange('title', e.target.value)}
            />
            <Stack direction={device === 'mobile' ? 'column' : 'row'} spacing={4}>
                <DatePicker
                    disabledDate={(date) => date.isSameOrBefore(moment().subtract(1, 'day'))}
                    label={'Start Date'}
                    required
                    value={form.start_on ? moment(form.start_on) : null}
                    onChange={(date) => handleChange('start_on', date.valueOf())}
                />
                <DatePicker
                    disabledDate={(date) => date.isSameOrBefore(moment(form.start_on))}
                    label={'End Date'}
                    required
                    value={form.end_on ? moment(form.end_on) : null}
                    onChange={(date) => handleChange('end_on', date.valueOf())}
                />
            </Stack>
            <Stack
                direction={'row-reverse'}
                justifyContent={device === 'mobile' ? 'space-between' : 'initial'}
                spacing={4}
            >
                <Button disabled={!canSubmit} onClick={handleClick}>
                    Save
                </Button>
                {form.isDirty && (
                    <Button variant={'secondary'} onClick={() => setForm(defaultFormValues)}>
                        Cancel
                    </Button>
                )}
            </Stack>
        </Stack>
    );
};

export default ProjectSettings;
